import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const DocumentPDF = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5 4C3.5 3.17157 4.17157 2.5 5 2.5H19C19.8284 2.5 20.5 3.17157 20.5 4V7.5H19.5V4C19.5 3.72386 19.2761 3.5 19 3.5H5C4.72386 3.5 4.5 3.72386 4.5 4V7.5H3.5V4ZM4.5 16.5V20C4.5 20.2761 4.72386 20.5 5 20.5H19C19.2761 20.5 19.5 20.2761 19.5 20V16.5H20.5V20C20.5 20.8284 19.8284 21.5 19 21.5H5C4.17157 21.5 3.5 20.8284 3.5 20V16.5H4.5Z"
          fill={color}
        />
        <path
          d="M3 8.5C3 7.94772 3.44772 7.5 4 7.5H20C20.5523 7.5 21 7.94772 21 8.5V15.5C21 16.0523 20.5523 16.5 20 16.5H4C3.44772 16.5 3 16.0523 3 15.5V8.5Z"
          stroke={color}
        />
        <path
          d="M5.23746 15V9.18182H7.41928C7.86625 9.18182 8.24125 9.26515 8.54428 9.43182C8.8492 9.59848 9.07931 9.82765 9.23462 10.1193C9.39181 10.4091 9.47041 10.7386 9.47041 11.108C9.47041 11.4811 9.39181 11.8125 9.23462 12.1023C9.07742 12.392 8.84541 12.6203 8.53859 12.7869C8.23178 12.9517 7.85393 13.0341 7.40507 13.0341H5.95905V12.1676H7.26303C7.52439 12.1676 7.7384 12.1222 7.90507 12.0312C8.07174 11.9403 8.19484 11.8153 8.27439 11.6562C8.35583 11.4972 8.39655 11.3144 8.39655 11.108C8.39655 10.9015 8.35583 10.7197 8.27439 10.5625C8.19484 10.4053 8.07079 10.2831 7.90223 10.196C7.73556 10.107 7.5206 10.0625 7.25734 10.0625H6.29143V15H5.23746ZM11.8775 15H9.90589V9.18182H11.9173C12.4949 9.18182 12.9911 9.2983 13.4059 9.53125C13.8226 9.76231 14.1426 10.0947 14.3661 10.5284C14.5896 10.9621 14.7013 11.4811 14.7013 12.0852C14.7013 12.6913 14.5887 13.2121 14.3633 13.6477C14.1398 14.0833 13.8169 14.4176 13.3945 14.6506C12.9741 14.8835 12.4684 15 11.8775 15ZM10.9599 14.0881H11.8263C12.2317 14.0881 12.5697 14.0142 12.8406 13.8665C13.1114 13.7169 13.315 13.4943 13.4513 13.1989C13.5877 12.9015 13.6559 12.5303 13.6559 12.0852C13.6559 11.6402 13.5877 11.2708 13.4513 10.9773C13.315 10.6818 13.1133 10.4612 12.8462 10.3153C12.5811 10.1676 12.2515 10.0938 11.8576 10.0938H10.9599V14.0881ZM15.2228 15V9.18182H18.95V10.0653H16.2767V11.6449H18.6944V12.5284H16.2767V15H15.2228Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default DocumentPDF
